"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AccountCircle;

var React = _interopRequireWildcard(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}
/* eslint-disable */


function AccountCircle(props) {
  var color = props.color,
      size = props.size,
      customColor = props.customColor,
      className = props.className,
      dataTest = props.dataTest,
      ariaHidden = props.ariaHidden,
      ariaLabel = props.ariaLabel,
      reverseOnRtl = props.reverseOnRtl;
  return React.createElement(_Icon.default, {
    viewBox: "0 0 24 24",
    size: size,
    color: color,
    customColor: customColor,
    className: className,
    dataTest: dataTest,
    ariaHidden: ariaHidden,
    reverseOnRtl: reverseOnRtl,
    ariaLabel: ariaLabel
  }, React.createElement("path", {
    d: "M13.694 2.132C6.917 1.036 1.036 6.917 2.132 13.694c.698 4.087 3.987 7.476 8.174 8.174 6.777 1.096 12.658-4.785 11.562-11.562-.698-4.087-4.087-7.476-8.174-8.174zM12.2 18.977H11.9c-2.392 0-4.585-1.196-5.78-3.09.996-.498 2.092-.897 3.09-1.296l.498-.199c.199-.1.398-.299.398-.598.1-.498.1-.997-.2-1.395-.697-.698-1.295-1.595-1.295-3.888 0-1.794 1.196-3.289 2.99-3.488h.499c1.794 0 3.289 1.395 3.289 3.09v.398c0 2.293-.698 3.19-1.296 3.888-.299.398-.299.897-.2 1.395 0 .2.2.498.4.598l.498.2c1.096.398 2.093.797 3.09 1.295-1.296 1.794-3.29 2.99-5.682 3.09z"
  }));
}